const shapes = document.querySelector(".shapes");
const delay = setTimeout(()=>{
    shapes.classList.add("reveal-shapes");
}, 0);

//# sourceMappingURL=the-smith-website.69424949.js.map
